import { useCallback, useEffect, useRef } from 'react'

import { CustomPicker } from '@space-lib/components/customPicker'

import { useThemeContext } from '@space-lib/hooks'

import { useI18n } from './hooks/useI18n/useI18n'
import { PickerContainer } from './styles'
import type { EmojiPickerProps } from './types'

const EmojiPicker = ({ isOpen, handleSelectEmoji, close, custom }: EmojiPickerProps) => {
  const i18n = useI18n()
  const { theme } = useThemeContext()
  const ref = useRef<HTMLDivElement>(null)

  const handleClick = useCallback(
    (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        close()
      }
    },
    [close]
  )

  useEffect(() => {
    document.addEventListener('click', handleClick, true)

    return () => {
      document.removeEventListener('click,', handleClick, true)
    }
  }, [handleClick])

  return (
    <div className='_position-relative'>
      {isOpen ? (
        <PickerContainer ref={ref} className='_position-absolute' data-test='picker-container'>
          <CustomPicker
            onEmojiSelect={handleSelectEmoji}
            theme={theme}
            i18n={i18n}
            custom={custom}
          />
        </PickerContainer>
      ) : null}
    </div>
  )
}

export default EmojiPicker
